module.exports = __webpack_public_path__ + "img/Pic_QGYSFB.41882ed1.png";